import React, { useEffect } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import MLPolicySummaryComponent from '../../Components/MLPolicySummaryComponent/MLPolicySummaryComponent';
import MLAccountQuotesComponent from '../../Components/MLAccountQuotesComponent/MLAccountQuotesComponent';
import MLAccountPendingPolicyChangesComponent from '../../Components/MLAccountPendingPolicyChangesComponent/MLAccountPendingPolicyChangesComponent';

import metadata from './MLAccountSummary.metadata.json5';
import messages from './MLAccountSummary.messages';
import styles from './MLAccountSummary.module.scss';

const MLAccountSummary = (props) => {
    const { accountInfo, updateAccountInfo } = props;

    const {
        addWarningAlert
    } = MLNotificationBlockUtil();

    const translator = useTranslator();

    const overrideProps = {
        alertGroupComponent: {
            noWizard: true,
            className: styles.alertGroupComponent
        },
        policySummaryComponent: {
            policySummaries: accountInfo.policySummaries,
            legacyPolicies: accountInfo.legacyPolicies
        },
        accountQuotesComponent: {
            visible: accountInfo.openQuotes_ML.length > 0,
            quotes: accountInfo.openQuotes_ML   
        },
        accountPendingPolicyChangesComponent: {
            accountNumber: accountInfo.accountNumber,
            pendingPolicyChanges: accountInfo.pendingPolicyChanges,
            updatePendingPolicyChanges: (pendingPolicyChanges) => {
                const currentAccountInfo = _.clone(accountInfo);
                currentAccountInfo.pendingPolicyChanges = pendingPolicyChanges;
                updateAccountInfo(currentAccountInfo);
            },
            visible: !_.isEmpty(accountInfo.pendingPolicyChanges)
        }
    }

    const resolvers = {
        resolveComponentMap: {
            MLAlertGroupComponent,
            MLPolicySummaryComponent,
            MLAccountQuotesComponent,
            MLAccountPendingPolicyChangesComponent
        },
        resolveClassNameMap: styles
    };

    const filterPoliciesByDelinquency = (policies) => {
        return policies.filter(({delinquent, isCancelled}) => delinquent && !isCancelled);
    };

    const displayWarningMessageForDelinquency = (delinquentPolicies) => {
        delinquentPolicies.forEach((policy) => {
            const errorMsg = translator(messages.delinquencyWarning, {policyNumber: policy.policyNumber});         
            addWarningAlert(errorMsg, `non_payment_${policy.policyNumber}`);
        });
    };

    useEffect(()=> {
        const delinquentPolicies = filterPoliciesByDelinquency(accountInfo.policySummaries);
        displayWarningMessageForDelinquency(delinquentPolicies);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    

    
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default MLAccountSummary;